module.exports = __webpack_public_path__ + "static/media/round-triangle-orange.58c7a687.svg";